export enum ParticipantState {
  PENDING = 'PENDING',
  REQUEST_CHANGE = 'REQUEST_CHANGES',
  DONE = 'DONE'
}
